import axiosInstance from "~/shared/api/axios-instance";
import { CSRF_STORAGE_KEY } from "~/shared/constants/auth";
import { getCookieValue } from "~/shared/lib/auth";

const API_URL = "account/login/";

export const login = async ({ email, password }: { email: string; password: string }) => {
  const response = await axiosInstance.post(API_URL, {
    // kenny: 레거시 백엔드에서 username으로 받음
    username: email,
    password,
  });

  // 로그인 성공 후 csrftoken 저장 시도
  const fromCookie = getCookieValue("csrftoken");
  if (fromCookie) {
    localStorage.setItem(CSRF_STORAGE_KEY, fromCookie);
  }
  if (response.data?.csrftoken) {
    localStorage.setItem(CSRF_STORAGE_KEY, response.data.csrftoken);
  }

  return response.data;
};
